import React from 'react';
import Navbar from './Navbar';
import { FaPiggyBank } from "react-icons/fa";
import { AiOutlineFileProtect } from "react-icons/ai";
import { FaTools, FaAward } from "react-icons/fa";
import { GiWorld } from "react-icons/gi";
import CountUp from "react-countup";
import Review from "./hooks/Review";
import Footer from "./hooks/Footer"
import TradingViewWidget from './hooks/TradingViewWidget';
import InvestBox from "./hooks/InvestBox"


const Home = () => {
    return (
        <>
     <TradingViewWidget />
            <div className="relative h-fit pb-[10%] bg-cover bg-center" style={{ backgroundImage: "url('aurofxx.png')" }}>
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <Navbar />

                <div className="mx-auto md:max-w-7xl overflow-hidden xl:pt-[15%] pt-[40%] relative">
                    <div className="grid mx-3 grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-2 sm:grid-cols-1 md:grid-cols-1">
                        <div className="bg-gree-500 h-fit">
                            <div className='xl:pl-10 pl-5'>
                                <p className='text-[25px] font-bold text-white'>Invest in Your Future, Today</p>

                                <div className='mt-5'>
                                    <p className='font-semibold text-gray-400'>Access 40,000+ instruments – across asset classes – to trade, hedge and invest from a single account.</p>
                                </div>

                                <div className='flex text-white mt-10 gap-5'>
                                   <a href="https://app.portpayinvestment.com/register" target='_blank' rel="noreferrer">
                                     <button className='btn__sign'><i class="ri-account-circle-line"></i> Open Account</button>
                                   </a>
                                   <a href="https://app.portpayinvestment.com/login" target='_blank' rel="noreferrer">
                                    <button className='btn__sign'><i class="ri-lock-2-line"></i> Login Account</button>
                                   </a>
                                </div>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
            <div className="bg__color p-5">
                <div className="mx-auto md:max-w-7xl overflow-hidden">
                    <div className="grid mx-3 grid-cols-1 gap-5 lg:grid-cols-4">
                        <div className="h-fit border-b md:border-b-0 md:border-r border-gray-600 pb-2 md:pb-0">
                            <p className="text-gray-300 font-semibold">Free <br />analysis tools</p>
                        </div>
                        <div className="h-fit border-b md:border-b-0 md:border-r border-gray-600 pb-2 md:pb-0 md:pl-5">
                            <p className="text-gray-300 font-semibold">Fast execution <br />0 commission</p>
                        </div>
                        <div className="h-fit border-b md:border-b-0 md:border-r border-gray-600 pb-2 md:pb-0 md:pl-5">
                            <p className="text-gray-300 font-semibold">Low minimum <br />deposit</p>
                        </div>
                        <div className="h-fit pb-2 md:pb-0 md:pl-5">
                            <p className="text-gray-300 font-semibold">Over 2,100 <br />assets to trade</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='bg-black h-fit pb-10'>
                <div className='mx-auto md:max-w-7xl overflow-hidden'>
                    <div className='pt-10 mx-5'>
                        <p className='xl:text-[42px] text-[35px] text-white font-[500]'>Industry-leading prices</p>
                        <div>
                            <p className='text-gray-400 font-[300] text-[20px]'>Get ultra-competitive spreads and commissions across all asset classes. <br /> Receive even better rates as your volume increases.</p>
                        </div>
                    </div>
                </div>

                <div className='mx-auto md:max-w-7xl overflow-hidden'>
                    <div className='grid xl:mt-0 mx-3 grid-cols-1 gap-5 lg:grid-cols-4 xl:grid-cols-4 z-10 relative  sm:grid-cols-1 md:grid-cols-2 pt-10'>
                        <div className="relative bg-green-400">
                            <img
                                src="https://ssir.org/images/blog/Lamy-Leijonhufvud-ODonohoe-next-decade-impact-invest-592x444.jpg"
                                alt=""
                                className="w-full h-full object-cover min-h-[300px]"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center p-5">
                                <div className="space-y-3 text-center">
                                    <p className="text-white text-md font-semibold">
                                        FX<i className="ri-arrow-right-s-line"></i>
                                    </p>
                                    <div>
                                        <p className="text-gray-300 font-bold">Spread as low as</p>
                                    </div>
                                    <div className="pt-3">
                                        <p className="font-bold text-[45px] leading-[61.6px] text-white">0.2</p>
                                        <span className="text-gray-300 font-[14px]">pip</span>
                                    </div>
                                    <div className="pt-5">
                                        <p className="text-gray-200 font-[14px]">
                                            Trade 182 FX spot pairs and 140 forwards across majors, minors, exotics, and metals.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="relative bg-green-400">
                            <img
                                src="https://cdn.prod.website-files.com/634054c00f602044abb3060d/65420f31d0dca45622658cfb_NEXT%20100X%20Crypto%20Millions.webp"
                                alt=""
                                className="w-full h-full object-cover min-h-[300px]"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center p-5">
                                <div className="space-y-3 text-center">
                                    <p className="text-white text-md font-semibold">
                                        Crypto<i className="ri-arrow-right-s-line"></i>
                                    </p>
                                    <div>
                                        <p className="text-gray-300 font-bold">Trade from</p>
                                    </div>
                                    <div className="pt-3">
                                        <p className="font-bold text-[45px] leading-[61.6px] text-white">0.4</p>
                                        <span className="text-gray-300 font-[14px]">on $500</span>
                                    </div>
                                    <div className="pt-5">
                                        <p className="text-gray-200 font-[14px]">
                                            Trade and invest confidently in top performing Cryptocurrencies with our timely Trading signals.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="relative bg-green-400">
                            <img
                                src="https://imageio.forbes.com/specials-images/imageserve/66bcb02d4b0426780199c445/An-increasing-arrow-that-represents-the-best-undervalued-stocks-rising-in-value-/1960x0.jpg?format=jpg&width=960"
                                alt=""
                                className="w-full h-full object-cover min-h-[300px]"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center p-5">
                                <div className="space-y-3 text-center">
                                    <p className="text-white text-md font-semibold">
                                        Stocks <i className="ri-arrow-right-s-line"></i>
                                    </p>
                                    <div>
                                        <p className="text-gray-300 font-bold">Commissions from</p>
                                    </div>
                                    <div className="pt-3">
                                        <p className="font-bold text-[45px] leading-[61.6px] text-white">$3</p>
                                        <span className="text-gray-300 font-[14px]">on US stocks</span>
                                    </div>
                                    <div className="pt-5">
                                        <p className="text-gray-200 font-[14px]">
                                            Access 19,000+ stocks across core and emerging markets on 36 exchanges worldwide.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="relative bg-green-400">
                            <img
                                src="https://realestateinvestingwomen.com/wp-content/uploads/2024/05/factors-to-make-real-estate-investment-in-islamabad-jpg.webp"
                                alt=""
                                className="w-full h-full object-cover min-h-[300px]"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center p-5">
                                <div className="space-y-3 text-center">
                                    <p className="text-white text-md font-semibold">
                                        Real Estate<i className="ri-arrow-right-s-line"></i>
                                    </p>
                                    <div>
                                        <p className="text-gray-300 font-bold">Procure for as low as</p>
                                    </div>
                                    <div className="pt-3">
                                        <p className="font-bold text-[45px] leading-[61.6px] text-white">$100</p>
                                        <span className="text-gray-300 font-[14px]">per slot</span>
                                    </div>
                                    <div className="pt-5">
                                        <p className="text-gray-200 font-[14px]">
                                            Simplified Real Estate investment for relatively small amounts through our crowdfunding model.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="mx-auto md:max-w-7xl overflow-hidden pt-10">
                    <div className="grid mx-3 grid-cols-1 gap-5 lg:grid-cols-4">
                        <div className="h-fit border-b md:border-b-0 md:border-r border-gray-600 pb-2 md:pb-0">
                            <p className="text-gray-300 font-semibold"> <i class="ri-medal-line text-[#3b82f6]"></i> Award-winning <br />support</p>
                        </div>
                        <div className="h-fit border-b md:border-b-0 md:border-r border-gray-600 pb-2 md:pb-0 md:pl-5">
                            <p className="text-gray-300 font-semibold"><i class="ri-bank-line text-[#3b82f6]"></i> Regulated by <br /> the US,UK +15</p>
                        </div>
                        <div className="h-fit border-b md:border-b-0 md:border-r border-gray-600 pb-2 md:pb-0 md:pl-5">
                            <p className="text-gray-300 font-semibold"><i class="ri-star-line text-[#3b82f6]"></i> 10 years <br /> experience</p>
                        </div>
                        <div className="h-fit pb-2 md:pb-0 md:pl-5">
                            <p className="text-gray-300 font-semibold"><i class="ri-group-fill text-[#3b82f6]"></i> Trusted By 82k+ <br />Clients</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='bg-[#2a2929] h-fit pb-10'>
                <div className='mx-auto md:max-w-7xl overflow-hidden pt-10'>
                    <div className='grid mx-3 grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-2 sm:grid-cols-1 md:grid-cols-1'>
                        <div className='bg-'>
                            <div className='p-5'>
                                <p className='xl:text-[42px] text-[35px] font-bold text-white'>Market analysis and trade inspiration.</p>

                                <div className='pt-5'>
                                    <p className='text-gray-300'>With a thriving network of experts, The Industradeacad clients gain access to numerous investment opportunities.  Powerful market insights and the industry's top trade setups are available.  Extensive connections to professional traders are also provided.
</p>
                                </div>

                                <div className='mt-10'>
                                    <a href="https://app.portpayinvestment.com/register" target='_blank' rel="noreferrer">
                                        <button className='bg-[#3b82f6] text-white font-semibold rounded-md p-3'>Start Investing <i class="ri-arrow-right-s-line"></i></button>
                                    </a>
                                   
                                </div>
                            </div>
                        </div>
                        <div>
                            <img src="https://media.istockphoto.com/id/1323542329/photo/woman-is-checking-bitcoin-price-chart-on-digital-exchange-on-smartphone-cryptocurrency-future.jpg?s=612x612&w=0&k=20&c=AGoQBhJUN13ESkgc3MAxFPYGEK4WCpl4gSS-uBha-yI=" alt="" className='rounded-md' />
                        </div>
                    </div>

                </div>
            </div>
                    <div>
                        <InvestBox/>
                    </div>
            <div className='bg-black h-fit pb-10'>
                <div className='mx-auto md:max-w-7xl overflow-hidden'>
                    <div className='flex justify-center pt-5'>
                        <p className='text-white font-bold xl:text-[40px] text-center text-[30px]'>Investment Plans</p>
                    </div>


                    <div className='grid xl:mt-0 mx-3 grid-cols-1 gap-5 lg:grid-cols-4 xl:grid-cols-4 z-10 relative  sm:grid-cols-1 md:grid-cols-2 pt-10'>
                        <div className='bg-gray-900 text-white p-6 rounded-md h-fit'>
                            <div className="text-sm text-[#3b82f6] font-bold uppercase">
                                Minimum Funding
                            </div>

                            <div className="text-2xl text-[#3b82f6] font-bold mt-2">$500</div>
                            <div className="text-xl font-bold mt-4">Basic account</div>
                            <div className="text-gray-300 mt-2">
                                Benefit from industry-leading entry prices
                            </div>
                            <hr className="my-4 border-gray-700" />
                            <ul className="space-y-2 text-sm">
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>min. possible deposit:
                                    $500
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>min. Expected profit:
                                    $4,500
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>max. Expected profit:
                                    $5,000
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Highly-regarded trader
                                    education*
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Advanced risk
                                    management
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Tax-free spread betting
                                    profits
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6]  mr-2">✔</span>Low minimum deposit
                                </li>
                            </ul>
                            <a href="https://app.portpayinvestment.com/register" target='_blank'  rel="noreferrer">
                            <button className="bg-[#3b82f6] text-gray-900 font-bold py-2 px-4 mt-6 w-full rounded-md hover:bg-green-600">
                                Open an account
                            </button>
                            </a>
                        </div>
                        <div className='bg-gray-900 text-white p-6 rounded-md h-fit'>
                            <div className="text-sm text-[#3b82f6] font-bold uppercase">
                                Minimum funding
                            </div>

                            <div className="text-2xl text-[#3b82f6] font-bold mt-2">$10,000</div>
                            <div className="text-xl font-bold mt-4">Classic account</div>
                            <div className="text-gray-300 mt-2">
                                Receive even tighter spreads and commissions
                            </div>
                            <hr className="my-4 border-gray-700" />
                            <ul className="space-y-2 text-sm">
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>min. possible deposit: $5,000
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>min. expected profit: $15,000
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>max. expected profit: $50,000
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Expert news & analysis
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Competitive spreads
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Tax-free spread betting
                                    profits
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Advanced trading tools
                                </li>
                            </ul>
                            <a href="https://app.portpayinvestment.com/register" target='_blank'  rel="noreferrer">
                            <button className="bg-[#3b82f6] text-gray-900 font-bold py-2 px-4 mt-6 w-full rounded-md hover:bg-green-600">
                                Open an account
                            </button>
                            </a>
                        </div>
                        <div className='bg-gray-900 text-white p-6 rounded-md h-fit'>
                            <div className="text-sm text-[#3b82f6] font-bold uppercase">
                                Minimum funding
                            </div>

                            <div className="text-2xl text-[#3b82f6] font-bold mt-2">$499,000</div>
                            <div className="text-xl font-bold mt-4">Platinum account</div>
                            <div className="text-gray-300 mt-2">
                                Benefit from industry-leading entry prices
                            </div>
                            <hr className="my-4 border-gray-700" />
                            <ul className="space-y-2 text-sm">
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>min. possible deposit: $10,000
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>min. expected profit: $39,999
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>With Full Executive benefits...
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Highly-regarded trader education
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Advanced risk management
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Tax-free spread betting profits
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Low minimum deposit
                                </li>
                            </ul>
                            <a href="https://app.portpayinvestment.com/register" target='_blank'  rel="noreferrer">
                            <button className="bg-[#3b82f6] text-gray-900 font-bold py-2 px-4 mt-6 w-full rounded-md hover:bg-green-600">
                                Open an account
                            </button>
                            </a>
                        </div>
                        <div className='bg-gray-900 text-white p-6 rounded-md h-fit'>
                            <div className="text-sm text-[#3b82f6] font-bold uppercase">
                                Minimum funding
                            </div>

                            <div className="text-2xl text-[#3b82f6] font-bold mt-2">$10,000 per month</div>
                            <div className="text-xl font-bold mt-4">Forex Signal Subscription</div>
                            <div className="text-gray-300 mt-2">
                                Receive even tighter spreads and commissions
                            </div>
                            <hr className="my-4 border-gray-700" />
                            <ul className="space-y-2 text-sm">
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Professional Forex Signals
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Up to 10 Signals/day
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>95% Success Rate
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Support 24/7
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>No Experience Required
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>Pay using bitcoin only
                                </li>
                                <li className="flex items-start">
                                    <span className="text-[#3b82f6] mr-2">✔</span>No Experience Required
                                </li>
                            </ul>
                            <a href="https://app.portpayinvestment.com/register" target='_blank'  rel="noreferrer">
                            <button className="bg-[#3b82f6] text-gray-900 font-bold py-2 px-4 mt-6 w-full rounded-md hover:bg-green-600">
                                Open an account
                            </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>


            <div className='bg-[#2a2929] h-fit pb-[5%]'>
                <div className="mx-auto md:max-w-7xl overflow-hidden pt-10">
                    <div className="text-center mb-10">
                        <h4 className="text-[white] font-semibold">Trade with confidence</h4>
                        <h2 className="text-3xl font-bold mt-2 text-white">
                            New level of security
                        </h2>
                    </div>
                    <div className="grid mx-3 grid-cols-1 lg:grid-cols-[1fr_1px_1fr] gap-5 items-center">
                        {/* Left Box */}
                        <div className="p-6 rounded-md">
                            <div className="flex items-start space-x-4">
                                <div>
                                    <FaPiggyBank size={40} color="#3b82f6" />
                                </div>
                                <h3 className="text-xl font-bold text-white">Regulations & funds</h3>
                            </div>
                            <p className="text-white mt-4 leading-relaxed">
                                Governments issue regulations related to environmental practices,
                                employee practices, advertising practices, and much more.
                                Furthermore, government regulations affect how companies structure
                                their businesses, where companies decide to locate, how they
                                classify their employees, and thousands of other things.
                            </p>
                        </div>

                        {/* Divider Line */}
                        <div className="hidden lg:block h-full bg-gray-500 mx-auto w-[1px]"></div>

                        {/* Right Box */}
                        <div className="p-6 rounded-md">
                            <div className="flex items-start space-x-4">
                                <div>
                                    <AiOutlineFileProtect size={40} color="#3b82f6" />
                                </div>
                                <h3 className="text-xl font-bold text-white">Depth of protection</h3>
                            </div>
                            <p className="text-white mt-4 leading-relaxed">
                                Defense-in-depth is an information assurance strategy that provides
                                multiple, redundant defensive measures in case a security control
                                fails or a vulnerability is exploited. It originates from a military
                                strategy by the same name, which seeks to delay the advance of an
                                attack rather than defeating it with one strong line of defense.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='bg-black h-screen'>
                <div className="bg-black text-white py-10">
                    <div className="text-center mb-10">
                        <h2 className="text-3xl font-bold">Join a club of more than 480,000 traders</h2>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mx-auto md:max-w-7xl px-6">
                        {/* Terms of Service */}
                        <div className="flex flex-col items-center text-center p-5">
                            <div className="bg-blue-500 p-4 rounded-full mb-4">
                                <FaAward size={40} className="text-white" />
                            </div>
                            <h3 className="text-xl font-bold mb-2">Best reputation</h3>
                            <p className="text-gray-400 text-sm mb-4">
                                Licensed and regulated across multiple jurisdictions, we serve clients in over 150 countries worldwide.
                            </p>

                        </div>

                        {/* Divider */}
                        <div className="hidden lg:block w-[1px] bg-gray-700 mx-auto"></div>

                        {/* Policies */}
                        <div className="flex flex-col items-center text-center p-5">
                            <div className="bg-blue-500 p-4 rounded-full mb-4">
                                <FaTools size={40} className="text-white" />
                            </div>
                            <h3 className="text-xl font-bold mb-2">Advanced tools</h3>
                            <p className="text-gray-400 text-sm mb-4">
                                Once you have selected your package you will receive an instant invitation to join the group chat. You will see around 10 signals per day with live updates.
                            </p>

                        </div>

                        {/* Divider */}
                        <div className="hidden lg:block w-[1px] bg-gray-700 mx-auto"></div>

                        {/* Security */}
                        <div className="flex flex-col items-center text-center p-5">
                            <div className="bg-blue-500 p-4 rounded-full mb-4">
                                <GiWorld size={40} className="text-white" />
                            </div>
                            <h3 className="text-xl font-bold mb-2">Worldwide office</h3>
                            <p className="text-gray-400 text-sm mb-4">
                                Knowing well that we are opened to investors we have added a multi currency support system for investors far and wide.
                            </p>

                        </div>
                        <div className="hidden lg:block w-[1px] bg-gray-700 mx-auto"></div>
                    </div>
                </div>


            </div>


            <div>
                {/* Stats Section */}
                <div className="bg-black text-white py-10">
                    {/* Heading */}
                    <div className="text-center mb-10">
                        <h2 className="text-3xl font-bold">Why Investors choose Us</h2>
                    </div>

                    {/* Statistics Section */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mx-auto md:max-w-7xl px-6 text-center">
                        {/* Experience */}
                        <div className="flex flex-col items-center">
                            <h3 className="text-5xl font-bold">
                                <CountUp start={0} end={10} duration={2} />
                            </h3>
                            <p className="text-xl">years</p>
                            <p className="font-bold mt-2">Experience</p>
                            <p className="text-gray-400 text-sm">Since 2013</p>
                        </div>

                        {/* UK Regulated */}
                        <div className="flex flex-col items-center">
                            <h3 className="text-5xl font-bold">
                                <CountUp start={0} end={7} duration={2} />
                            </h3>
                            <p className="text-xl">years+</p>
                            <p className="font-bold mt-2">UK Regulated</p>
                            <p className="text-gray-400 text-sm">Since 2016</p>
                        </div>

                        {/* Signal Orders */}
                        <div className="flex flex-col items-center">
                            <h3 className="text-5xl font-bold">
                                <CountUp start={0} end={100} duration={2} />
                            </h3>
                            <p className="text-xl">Signal orders per day</p>
                            <p className="text-gray-400 text-sm">Fast execution after payment</p>
                        </div>

                        {/* Operational Support */}
                        <div className="flex flex-col items-center">
                            <h3 className="text-5xl font-bold">
                                <CountUp start={0} end={24} duration={2} />
                                <span className="text-xl">/7</span>
                            </h3>
                            <p className="text-xl">Operational support</p>
                            <p className="text-gray-400 text-sm">
                                High-quality, 24/7 support at all stages of co-operation.
                            </p>
                        </div>
                    </div>
                </div>

                <div>
                    <Review/>
                </div>
               

                {/* Footer Section */}
                <Footer />
            </div>
           
        </>
    );
};

export default Home;
